import type { PermissionProduct, PermissionUser } from '@oy/types';
import update from 'immutability-helper';
import { ActionType, defaultAction } from '../types';
import { PERMISSION_ACTION_TYPES } from '../types/permissionTypes';

export type PermissionState = {
  permissionProducts: PermissionProduct[];
  userPermissions: PermissionUser[];
  isLoading: boolean;
};

const initialState: PermissionState = {
  permissionProducts: [],
  userPermissions: [],
  isLoading: false,
};

function permissionReducer(
  state = initialState,
  action: ActionType = defaultAction,
) {
  const { payload, type } = action;
  switch (type) {
    case PERMISSION_ACTION_TYPES.SET_PRODUCT_PERMISSIONS:
      return update(state, {
        $merge: {
          permissionProducts: payload,
        },
      });
    case PERMISSION_ACTION_TYPES.SET_USER_PERMISSIONS:
      return update(state, {
        $merge: {
          userPermissions: payload,
        },
      });
    default:
      return state;
  }
}

export default permissionReducer;
